import React, { useState } from 'react'
import { useParams, useLocation } from 'react-router-dom';

import { useGetStudentDetails } from '../../../hooks/students';

import StudentDetailsLayout from '../../layouts/Student';
import ChatPreviewCard from '../../sub_components/ChatPreviewCard';
import Chats from '../../sub_components/student/notifications/Chats';
import { TabContainer } from '../../sub_components/Tabs';

// import Loader from '../reusables/Loader';

import { StudentNotificationsTab } from '../../../interfaces/student';
import { useGetExpertConversationsWithChatsForStudent } from '../../../hooks/users';

const NotificationsPage = () => {
    const location = useLocation();

    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const tabItems = [
        { id: 'Alerts', label: 'Alerts' },
        { id: 'Chats', label: 'Chats' },
        { id: 'Comments', label: 'Comments' },
    ];

    const [currentTab, setCurrentTab] = useState<StudentNotificationsTab>('Alerts');

    const { data: student } = useGetStudentDetails(studentId);

    const handleTabChange = (tabId: string) => {
        setCurrentTab(tabId as StudentNotificationsTab);
    };

    const { data: expertConversations } = useGetExpertConversationsWithChatsForStudent(studentId);

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation='update'
            currentTab="Notifications"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className='immersion__common_details__sub_info_view'>
                    <TabContainer
                        items={tabItems}
                        activeTab={currentTab}
                        onChange={handleTabChange}
                        variant="content"
                    />
                    <div className="immersion__common_details__sub_info__forms_container">
                        {currentTab === 'Chats' && !!expertConversations?.length &&
                            <Chats>
                                {expertConversations.map((expertConversation) => (
                                    <ChatPreviewCard
                                        key={expertConversation.id}
                                        expertConversation={expertConversation}
                                    />
                                ))}
                            </Chats>
                        }
                    </div>
                </div>
            </div>
        </StudentDetailsLayout>
    )
}

export default NotificationsPage;